import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------UI--------------- */
import { Text } from "react-native-paper";

import type { IconType } from "../../../icon";
import { useAppTheme } from "../../../useAppTheme";
/* -----------------Child components--------------- */
import Box from "../../Box";
import Button from "../../Button";

type Props = {
	handleAction: () => void;
	inReviewMode?: boolean;
	timeRemaining?: string;
	isTimerExpired?: boolean;
	showPause?: boolean;
	itemTypeText?: string;
};

const StudySessionAppbarRight = ({
	handleAction,
	inReviewMode,
	timeRemaining,
	isTimerExpired,
	showPause = true,
	itemTypeText,
}: Props) => {
	const theme = useAppTheme();

	const icon = inReviewMode ? "check-circle-outline" : "pause-circle-outline";
	const cta = inReviewMode ? "End Review" : "Pause Session";
	return (
		<Box flexDirection="row" alignItems="center" gap={16}>
			<Box flexDirection="row" alignItems="center" gap={6}>
				<Icon
					name={inReviewMode ? "format-list-checks" : "clock-outline"}
					size={24}
					color={theme.colors.white}
				/>
				{inReviewMode ? (
					itemTypeText ? (
						<Text
							variant="labelSmall"
							style={{
								color: theme.colors.white,
							}}
						>
							{itemTypeText}
						</Text>
					) : null
				) : (
					<Text
						variant="titleMedium"
						style={{
							color: isTimerExpired ? theme.colors.error : theme.colors.white,
						}}
					>
						{timeRemaining}
					</Text>
				)}
			</Box>
			{showPause && (
				<Button
					icon={icon as IconType}
					mode="outlined"
					style={{
						borderColor: theme.colors.white,
					}}
					textColor={theme.colors.white}
					onPress={handleAction}
				>
					{cta}
				</Button>
			)}
		</Box>
	);
};

export default StudySessionAppbarRight;
